import React from 'react';
import { CreditCard } from 'lucide-react';

const AdditionalInformation = ({ nif, onChange, translations }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
        <CreditCard className="w-5 h-5 mr-2 text-blue-600" />
        {translations("profile.additionalInfo")}  

      </h2>
      <div>
        <label htmlFor="nif" className="block text-sm font-medium text-gray-700">
        {translations("profile.nif")}  

        </label>
        <input
          type="text"
          id="nif"
          value={nif}
          onChange={onChange}
          className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>
  );
};

export default AdditionalInformation;